// extracted by mini-css-extract-plugin
export default {"checkboxControl":"Checkbox-module__checkboxControl___mqfmR","checkboxInput":"Checkbox-module__checkboxInput___H9heR","checkboxLabel":"Checkbox-module__checkboxLabel___BFY47"};